<div class="video-options-container">
    <div class="video-options-menu">
        <video-call-options></video-call-options>
    </div>
    <div class="video-options-content"></div>
</div>